import { createAction, props } from '@ngrx/store';

import { IUser } from '../interfaces';

export const getUser = createAction(
  '[User] Get User',
);

export const getUserSuccess = createAction(
  '[User] Get User Success',
  props<{ userData: IUser }>(),
);
